import Footer from '../Components/Footer'
import { useTranslation } from 'react-i18next'
import { Box, Container } from '@mui/material';
import { Variants, motion } from "framer-motion"
import DrawerAppBar from '../Components/DrawerAppBar';
import Menus from '../Components/Menus';
import TitrePage from '../Components/TitrePage';
import NosOffres from '../Components/NosOffres';
import { Typography } from 'antd';
import NousRejoindre from '../Components/NousRejoindre';
import { useNavigate } from 'react-router-dom';

interface Props { }

function EmploieEtCarriere(props: Props) {
        const { t } = useTranslation();
    const navigate = useNavigate()


    const scroll: Variants = {
        offscreen: {
            x: 80,
            opacity: .3
        },
        onscreen: {
            x: 0,
            opacity: 1,
            transition: {
                bounce: 0.6,
                duration: 1
            }
        }
    };

    function postules() {
        navigate("/postule")
    }


    return (
        <div style={{ backgroundColor: "inherit" }}>
            <DrawerAppBar /><br />
            <Menus />
            <TitrePage titre={'PRODUITS_SERVICES.titre39'} lien={'Label.Titre.titre14'} />
            <br /><br /><br /><br /><br /><br /><br /><br /><br />
            <Box display={{ xs: 'block', sm: 'none' }}>
                <br /><br />
            </Box>

            <Box>
                <Container maxWidth='lg'>
                    <NousRejoindre />
                </Container>
            </Box>
            <br /><br />


            <motion.div
                initial="offscreen"
                whileInView="onscreen"
                viewport={{ once: true, amount: 0.8 }}
                variants={scroll}
                className='produitsEtServices'
            >
                <Container maxWidth='lg'>
                    <Box className='boxCS'>
                        <Typography>{t("SOUS_TITRE.CandidatureSpontanee")}</Typography>
                        <br />
                        <motion.button
                            onClick={postules}
                            whileHover={{
                                scale: 1.2,
                                transition: { duration: 1 },
                            }}
                            whileTap={{ scale: 0.9 }}
                            className='btn'>{t("Bouton.Condidaturespontanee")}
                        </motion.button>
                    </Box>
                </Container>

            </motion.div>

            <br /><br />

            <Container maxWidth='lg'>
                <NosOffres />
            </Container>
            <br /><br /><br />

            <Footer />
        </div>
    )
}
export default EmploieEtCarriere